import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const links = [
  { to: "/nominations", label: "Nominations" },
  { to: "/spectacles", label: "Spectacles" },
  { to: "/jury", label: "Jury" },
  { to: "/voter", label: "Voter" },
  { to: "/ceremonie", label: "Cérémonie" },
  { to: "/manifeste", label: "Manifeste" },
  { to: "/presse", label: "Presse" },
  { to: "/archives", label: "Archives" },
];

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-40"
      style={{ background: "rgba(10,10,10,0.78)", backdropFilter: "blur(12px)", borderBottom: "1px solid #1c1c1c" }}
      data-testid="navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <Link to="/home" className="label" style={{ color: "#F8F6F0" }} data-testid="nav-brand">
          LE STAND D'OR
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) => "label transition-colors duration-500"}
              style={({ isActive }) => ({
                color: isActive ? "#C9A961" : "#F8F6F0",
              })}
              data-testid={`nav-link-${l.to.replace(/\//g, "") || "home"}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <span className="label" style={{ color: "#A1A1AA" }}>ÉDITION&nbsp;2026</span>
        </div>

        <button
          className="md:hidden label"
          style={{ color: "#F8F6F0" }}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? "FERMER" : "MENU"}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden"
          style={{ background: "#0A0A0A", borderTop: "1px solid #1c1c1c" }}
          data-testid="nav-mobile-panel"
        >
          <div className="flex flex-col">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="label px-6 py-5"
                style={{
                  color: location.pathname === l.to ? "#C9A961" : "#F8F6F0",
                  borderBottom: "1px solid #1c1c1c",
                }}
                data-testid={`nav-mobile-link-${l.to.replace(/\//g, "") || "home"}`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
